module.exports = __webpack_public_path__ + "media/Metalab_webtovr.0a27554c.mp4";